import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMobile: false,
  isTablet: false,
  isDesktop: false,
};

const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },

    setIsTablet: (state, action) => {
      state.isTablet = action.payload;
    },

    setIsDesktop: (state, action) => {
      state.isDesktop = action.payload;
    },
  },
});

export const { setIsMobile, setIsTablet, setIsDesktop } = deviceSlice.actions;
export default deviceSlice.reducer;
